import { utilityService } from '../../services/utilityService'
import * as actionTypes from './ActionTypes'

export const getCitiesSuccess = cities => {
  return {
    type: actionTypes.GET_CITIES_SUCCESS,
    payload: {
      cities,
    },
  }
}

export const getCities = () => async dispatch => {
  const response = await utilityService.getListOfCities()
  if (response.isOk && response.data) {
    dispatch(getCitiesSuccess(response.data.cities))
  }
}
